export enum ProcessoIdentificacaoPeticaoInicialModo {
  AUTOMATICO = 'AUTOMATICO',
  MANUAL = 'MANUAL',
  NENHUM  = 'NENHUM'
}
